import isESClass, { GroupedSuffix, NUMBERED_GRADE_RE } from './is-es-class';
import placeESClassesWithinRanges from './place-es-classes-within-ranges';

// Classes matching "N. SUFFIX" (PRIM, ESO, BACH, CFGM, CFGS, FPB) are grouped per suffix into ranges
// e.g., [grd1, 1. PRIM, 2. PRIM, EI, 1. ESO] -> [grd1, 1.-2. PRIM, EI, 1. ESO]
const getESGradesWithClassesWithinRange = (grades: MaterialClassGrade[]): string[] => {
    const allClasses = grades.filter(isESClass);

    if (!allClasses.length) {
        return grades.map(({ title }) => title);
    }

    const rangesBySuffix = placeESClassesWithinRanges(allClasses);
    const allGradesAreActuallyClasses = allClasses.length === grades.length;

    if (allGradesAreActuallyClasses) {
        // @ts-ignore
        return [...rangesBySuffix.values()];
    }

    const insertedSuffixes = new Set<GroupedSuffix>();

    return grades.reduce<string[]>((result, grade) => {
        if (!isESClass(grade)) {
            result.push(grade.title);

            return result;
        }

        const [, , suffix] = grade.title.match(NUMBERED_GRADE_RE) as [string, string, GroupedSuffix];

        if (!insertedSuffixes.has(suffix)) {
            insertedSuffixes.add(suffix);
            result.push(rangesBySuffix.get(suffix)!);
        }

        return result;
    }, []);
};

export default getESGradesWithClassesWithinRange;
